import { IComponentKey } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

/**
 * 🎯 Purpose:
 * Defines the list of widget component keys that their "compareTo" version should be ONLY the previous version
 */

export const COMPARE_TO_PREVIOUS_VERSION_COMPONENT_KEYS: IComponentKey[] = [
    'topFinishDateChanges',
    'changeSummary',
    'myVersionCompareTrackedActivities',
    'topStartDateChanges',
    'topStatusChanges',
    'largestAddedActivities',
    'largestDeletedActivities',
    'criticalPathAdded',
    'criticalPathRemoved',
    'largestFloatChanges',
    'largestDurationVariance',
    'topRelationshipsTypeChanges',
    'topRelationshipsCountChanges',
    'resourcesAnalysisChart',
    'resourcesAnalysisTable',
];
